import "./Highlights.scss"

import { Box, Button, Grid, Typography } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";

import { Mode } from "../../utils/utility";
import { TextField } from "../input/elements";
import { FilledTextFieldProps, OutlinedTextFieldProps, StandardTextFieldProps } from "../input/elements/TextField";

interface BaseHighlightProps {
  index: number;
}

interface StandardHighlightProps extends StandardTextFieldProps, BaseHighlightProps { }
interface FilledHighlightProps extends FilledTextFieldProps, BaseHighlightProps { }
interface OutlinedSHighlightProps extends OutlinedTextFieldProps, BaseHighlightProps { }

type HighlightProps = StandardHighlightProps | FilledHighlightProps | OutlinedSHighlightProps;

const Highlight = (props: HighlightProps) => {
  const {
    index,
    mode,
    value,
  } = props;

  return (
    <Box className="highlight">
      <Box className="bar">
        {mode === Mode.Edit &&
        <TextField
          { ...props }
        />
        }

        {mode === Mode.View &&
        <Typography variant="body1" className="text">
          {value as string}
        </Typography>
        }
      </Box>

      <Box className="circle">
        <Typography variant="body1" className="number">
          {index}
        </Typography>
      </Box>
    </Box>
  );
}

interface BaseHighlightsProps {
  error: Array<boolean | undefined>
  onChange: (value: Array<string>) => void;
  value: Array<string>;
}

type Omitted = 'error' | 'onChange' | 'value';

export interface StandardHighlightsProps extends Omit<StandardTextFieldProps, Omitted>, BaseHighlightsProps { }
export interface FilledHighlightsProps extends Omit<FilledTextFieldProps, Omitted>, BaseHighlightsProps { }
export interface OutlinedSHighlightsProps extends Omit<OutlinedTextFieldProps, Omitted>, BaseHighlightsProps { }

export type HighlightsProps = StandardHighlightsProps | FilledHighlightsProps | OutlinedSHighlightsProps;

export const Highlights = (props: HighlightsProps) => {
  const {
    error,
    mode,
    onChange,
    value,
  } = props;

  const { t } = useTranslation();

  const addHighlight = () => {
    if (onChange) {
      let highlights = [...value];
      highlights.push("");
      onChange(highlights);
    }
  }

  return (
    <Grid container direction="column" spacing={3}>
      <Grid item xs={12}>
        <Typography className="title">
          {t("Investment highlights")}
        </Typography>
      </Grid>

      {value.map((
        highlight, index
      ) =>
        <Grid item xs={12} key={index}>
          <Highlight
            { ...props }
            value={highlight}
            error={error?.[index]}
            index={index}
            onChange={(e: any) => {
              if (onChange) {
                value[index] = e.target.value;
                onChange(value);
              }
            }}
          />
        </Grid>)}

      {mode === Mode.Edit &&
      <Grid item xs={12}>
        <Box marginTop="45px">
          <Button
            className="primary"
            variant="contained"
            color="primary"
            fullWidth
            onClick={addHighlight}
          >
            {t("Add highlight")}
          </Button>
        </Box>
      </Grid>
      }
    </Grid>
  );
}